import React from 'react';
import { Link  } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import './footer.css';
import  GetLangConfig  from '../../util/LangUtil';

export default function Footer() {
    const history = useNavigate();
    const langConfig = GetLangConfig('footer');
    return (
        <div className="footer-container">
            <div>
                {langConfig.footer.copyright}
            </div>
            <div>
                <Link style={{ textDecoration: 'none' }} to="/faq">{langConfig.footer.faq}</Link>
                <div></div>
                <Link style={{ textDecoration: 'none' }} to="/privacypolicy">{langConfig.footer.privacy}</Link>
                <div></div>
                <Link style={{ textDecoration: 'none' }} to="termsofservice">{langConfig.footer.tos}</Link>
            </div>
        </div>
    );
}